// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperSelector-cls1_-M2","cls2":"PaperSelector-cls2_HxJ PaperSelector-cls1_-M2"};